import { useFormikContext } from 'formik';
import useLocale from '../../../../../app/hooks/useLocale';
import AppFormSectionSubtitle from '../../../components/AppFormSectionSubtitle';
import { IFormValuesPersonalInfo } from '../types';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { YesNoToggleField } from '../../../../../components/FormFields';
import useAppForm from '../../../hooks/useAppForm';
import { ClientPublicService } from '../../../../../app/api/ClientPublicService';
import { Divider } from '@mui/material';
import VoluntarySelfIdentificationValues from '../components/VoluntarySelfIdentificationValues';

const VoluntarySelfIdentification = () => {
  const { t } = useLocale();
  const { values } = useFormikContext<IFormValuesPersonalInfo>();
  const { appFileData, appFormStatus } = useAppForm() || {};

  const [consentToSelfIdentification, setConsentToSelfIdentification] = useState<boolean | undefined>(undefined);
  const [consentToSelfIdentificationSpouse, setConsentToSelfIdentificationSpouse] = useState<boolean | undefined>(
    undefined
  );

  const handleConsentToSelfIdentificationChange = useCallback((consentToSelfIdentificationValue: boolean) => {
    setConsentToSelfIdentification(consentToSelfIdentificationValue);
  }, []);

  const handleConsentToSelfIdentificationSpouseChange = useCallback(
    (consentToSelfIdentificationSpouseValue: boolean) => {
      setConsentToSelfIdentificationSpouse(consentToSelfIdentificationSpouseValue);
    },
    []
  );

  const isLocked = useMemo(
    () =>
      appFileData?.isLocked ||
      appFileData?.isAppFormLocked ||
      appFormStatus?.personalInfoStatus === ClientPublicService.AppFormStatusEnum.Complete,
    [appFileData?.isLocked, appFileData?.isAppFormLocked, appFormStatus?.personalInfoStatus]
  );

  const isJointFile = useMemo(() => values?.isJointFile, [values]);

  useEffect(() => {
    setConsentToSelfIdentification(values?.consentToSelfIdentification);
    setConsentToSelfIdentificationSpouse(values?.consentToSelfIdentificationSpouse);
  }, []);

  return (
    <>
      <AppFormSectionSubtitle>{t.APPLICANT}</AppFormSectionSubtitle>

      <YesNoToggleField
        label={t.DOES_THE_APPLICANT_CONSENT_TO_ANSWERING_THESE_QUESTIONS}
        name="consentToSelfIdentification"
        value={consentToSelfIdentification}
        onChange={handleConsentToSelfIdentificationChange}
        disabled={isLocked}
      />

      {consentToSelfIdentification && (
        <VoluntarySelfIdentificationValues name="selfIdentifications" isLocked={isLocked} isForSpouse={false} />
      )}

      <Divider sx={{ mt: 2, mb: 2 }} />

      {isJointFile && (
        <>
          <AppFormSectionSubtitle>{t.SPOUSE}</AppFormSectionSubtitle>

          <YesNoToggleField
            label={t.DOES_THE_SPOUSE_CONSENT_TO_ANSWERING_THESE_QUESTIONS}
            name="consentToSelfIdentificationSpouse"
            value={consentToSelfIdentificationSpouse}
            onChange={handleConsentToSelfIdentificationSpouseChange}
            disabled={isLocked}
          />

          {consentToSelfIdentificationSpouse && (
            <VoluntarySelfIdentificationValues
              name="selfIdentificationsSpouse"
              isLocked={isLocked}
              isForSpouse={true}
            />
          )}
        </>
      )}
    </>
  );
};

export default VoluntarySelfIdentification;
